/**
 * @description Класс для общения между iframe и страницей
 * */
export default class {
    constructor() {
        this._source = null;
        // Сразу ставим обработчик события message
        window.addEventListener("message", (event) => {
            if (typeof event.data !== 'string' || !~event.data.indexOf(":")) return;
            let message = [];
            let dotsIdx = event.data.indexOf(":");
            message[0] = event.data.slice(0, dotsIdx);
            message[1] = event.data.slice(dotsIdx + 1, event.data.length);
            // Если сообщение loaded, сообщаем высоту
            if (message[0] !== "loaded") return;
            this._source = event.source;
            this.postMessage(`height:${this.getHeight()}`);
            console.log('iframe set up successfully', message[1]);
        });
    }

    /**
     * @returns Number высота формы
     * @description Получаем высоту формы
     * */
    getHeight() {
        const bodyHeight = Math.ceil(document.body.getBoundingClientRect().height);
        const firstModal = document.querySelector('.fixed .modal');
        if (firstModal) {
            const modalHeight = Math.ceil(firstModal.getBoundingClientRect().height) + Math.ceil(firstModal.getBoundingClientRect().top) * 2;
            return modalHeight > bodyHeight ? modalHeight : bodyHeight;
        }

        return bodyHeight;
    }

    /**
     * @param {String} msg
     * @description Отправляет сообщение (если есть куда)
     * */
    postMessage(msg) {
        if (!this._source) return;
        this._source.postMessage(msg, '*');
    }

    /**
     * @param {Number} value
     * @description Отправляет сообщение для скролла или скроллит текущую страницу
     * */
    scrollTo(value) {
        if (this._source) {
            this.postMessage(`top:${value}`);
        } else {
            window.scrollTo({
                top: value + window.pageYOffset, behavior: 'smooth'
            })
        }
    }

    listen() {
        let setHeight = null;
        const step = () => {
            const height = this.getHeight();
            if (height !== setHeight) {
                setHeight = height;
                this.postMessage(`height:${setHeight}`);
            }
            requestAnimationFrame(step);
        }
        requestAnimationFrame(step)
    }

    isInIframe() {
        return Boolean(this._source);
    }
}
